/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, ember/no-mixins, ember/require-computed-property-dependencies */
import Component from '@ember/component';
// Ember imports
import { computed } from '@ember/object';
// Internal imports
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';

export default class ExpulsionPosts extends Component.extend(EditPostMixin) {
  PostTypes = PostTypes;
  expulsion = null;
  postMode = '';

  @computed(
    'expulsion.{expulsionPost.content,noticeOfPotentialExpulsions,noticeOfExpulsions,incident.post.content}',
  )
  get resolvedPosts() {
    let posts = [];
    switch (this.postMode) {
      case 'post':
        posts = [this.get('expulsion.expulsionPost.content')];
        break;
      case 'letters':
        this.get('expulsion.noticeOfPotentialExpulsions').forEach((post) => {
          posts.push(post);
        });
        this.get('expulsion.noticeOfExpulsions').forEach((post) => {
          posts.push(post);
        });
        posts.reverse();
        break;
      case 'incident':
        posts = [this.get('expulsion.incident.post.content')];
        break;
      default:
        break;
    }

    return posts;
  }
}
